import { sharedAtom } from '../utilities/jotai-utils';
import { storedAtomFactory } from '../utilities/stored-atom-utils';

const storageKey = 'selectedRegion';
const { storedAtom } = storedAtomFactory(storageKey);

export const firstPathState = sharedAtom('firstPathState', null);

export const embeddedParentOriginState = sharedAtom('embeddedParentOriginState', '*');

export const regionState = storedAtom({
  key: 'regionState',
  default: null
});

export const navMenuFeatures = sharedAtom('navMenuFeaturesState', []);

export const customersToRegionState = sharedAtom('customersToRegion', null);

export const processedTenantsState = sharedAtom('processedTenantsState', {
  tenants: [],
  rawTenants: [],
  removedById: {},
  isLoading: false
});

export const kbSectorsState = sharedAtom('knowledgeBaseSectors', {
  sectors: [],
  sectorsById: {},
  sectorsByName: {},
  idToName: {},
  nameToId: {},
  isLoading: false
});
